'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _priceString = require('helpers/priceString');

var _priceString2 = _interopRequireDefault(_priceString);

var _defaultClasses = require('../../../../../constants/defaultClasses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _renderTotal = function _renderTotal(components, data, selectedCurrencyFormat) {
  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.ApproximateTotalValueLabel)) },
            (0, _priceString2.default)(selectedCurrencyFormat, data.totalPrice, data.currency)
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          null,
          _react2.default.createElement(
            'span',
            { style: (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.ApproximateTotalTitleLabel)) },
            'Approximate total'
          )
        )
      )
    )
  );
};

var _renderText = function _renderText(components, text) {
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var textClass = title ? (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.PricePerNightTitleLabel)) : (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.PricePerNightValueLabel));

  return _react2.default.createElement(
    'span',
    { style: textClass },
    text || ''
  );
};

var _getTypeOfTitle = function _getTypeOfTitle(type) {
  switch (type) {
    case 'AveragePerNight':
      return 'average';

    case 'MinPrice':
      return 'min';

    case 'MaxPrice':
      return 'max';

    case 'PerNight':
      return 'night';

    default:
      return '';
  }
};

var _getTitle = function _getTitle(type) {
  switch (type) {
    case 'AveragePerNight':
      return 'Avg price per night: ';

    case 'MinPrice':
      return 'Min price per night: ';

    case 'MaxPrice':
      return 'Max price per night: ';

    case 'PerNight':
      return 'Price per night: ';

    default:
      return '';
  }
};

var _getText = function _getText(data, footerMessage, selectedCurrencyFormat) {
  return (0, _priceString2.default)(selectedCurrencyFormat, data.totalPrice, data.currency) + ' ' + (data.taxPrice > 0 ? ' (EXCL. TAXES ' + data.taxPrice + ') ' + footerMessage : '');
};

var _getTypeOfPrice = function _getTypeOfPrice(priceList) {
  var footerMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var result = {};

  priceList.forEach(function (priceElement) {
    var title = _getTypeOfTitle(priceElement.priceData.rateType);
    result = (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, title, {
      title: _getTitle(priceElement.priceData.rateType),
      text: _getText(priceElement.priceData, footerMessage)
    }));
  });
  return result;
};

var _renderData = function _renderData(typeOfPrices, components) {
  return (0, _keys2.default)(typeOfPrices).map(function (key, i) {
    return _react2.default.createElement(
      'td',
      { key: '' + key + i, style: (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.HotelPriceContainer), { padding: '10px' }) },
      typeOfPrices[key] && _renderText(components, typeOfPrices[key].title),
      typeOfPrices[key] && _renderText(components, typeOfPrices[key].text, false)
    );
  });
};

var _renderTotalData = function _renderTotalData(option, components, selectedCurrencyFormat) {
  return _react2.default.createElement(
    'td',
    { style: (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.HotelPriceContainer), { padding: '10px' }) },
    _renderTotal(components, option.totalPriceItem.priceData, selectedCurrencyFormat)
  );
};

function HotelTotalFooter(props) {
  var option = props.option,
      components = props.components,
      selectedCurrencyFormat = props.selectedCurrencyFormat;

  var typeOfPrices = _getTypeOfPrice(option.priceItemList, option.optionFooterMessage);

  return _react2.default.createElement(
    'table',
    { style: _defaultClasses.mainTableClass, 'data-component': 'HotelTotalFooter' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        { style: (0, _extends4.default)({}, (0, _defaultClasses.containerClass)(components.HotelPriceContainer)) },
        _renderData(typeOfPrices, components),
        _renderTotalData(option, components, selectedCurrencyFormat)
      )
    )
  );
}

var mstp = function mstp(state) {
  var basketCurrencyFormat = state.rendering.shopOptions.currencyFormat;
  return {
    selectedCurrencyFormat: basketCurrencyFormat || state.templateApplication.templates.currentTemplate.currencyFormat
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(HotelTotalFooter);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Passive/HotelTotalFooter.jsx
// module id = 1532
// module chunks = 0